var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestDesktopArrowNe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.5 0a1.5 1.5 0 1 0 0 3h6.379l-8.44 8.44A1.502 1.502 0 0 0 1.5 14c.384 0 .767-.146 1.06-.44L11 5.12v6.38a1.5 1.5 0 1 0 3 0V0z"
})));
export default SvgPinterestDesktopArrowNe;